import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CrioChip } from '@crio/crio-react-component/dist/cjs/components/DataDisplay';

interface AlertItem {
  message: string
  triggeringQuestions: string[]
}

interface AlertDetailsListProps {
  alerts: AlertItem[]
  questionTextMap: Record<string, string>,
  recordLabel?: string,
}

const AlertAccordionDetailsList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0 22px 22px 22px;
  max-width: 600px;

  &:last-of-type {
    padding-bottom: 0;
  }
`;

const AlertAccordionDetailsAlertHeader = styled.p`
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  margin: -4px 0 3px 0;
`;

const AlertAccordionDetailsAlertSubheader = styled.p`
  color: #666666;
  font-family: Poppins;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: ${(props) => props.theme.typography.fontSizes.xs};
`;

const AlertAccordionDetailsQuestionsList = styled.ul`
  list-style-type: none;
  color: ${(props) => props.theme.palette.grey[700]};
  padding-left: 20px;
  margin-top: -2px;
  line-height: 18px;
  font-size: ${(props) => props.theme.typography.fontSizes.xs};
`;

const AlertAccordionDetailsQuestionsListItem = styled.li`
  position: relative;

  ::before {
    content: '';
    display: block;
    width: 3px;
    height: 3px;
    background-color: ${(props) => props.theme.palette.grey[700]};
    border-radius: 50%;
    position: absolute;
    left: -12px;
    top: calc(50% - 2px);
  }
`;

const StyledList = styled.li`
  margin: 15px 0;

  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledCrioChip = styled(CrioChip)`
  && {
        font-weight: 400;
        color: #333333;
    }
`;
export const AlertDetailsList: React.FC<AlertDetailsListProps> = ({
  alerts,
  questionTextMap,
  recordLabel, // ← new
}) => {
  const { t } = useTranslation();

  return (
    <AlertAccordionDetailsList>
      {/* if recordLabel is passed in, render it as the first <li> */}
      {recordLabel && (
        <li>
          <StyledCrioChip label={recordLabel} size="small" />
        </li>
      )}

      {/* now render each alert in its own <li> */}
      {alerts.map(({ message, triggeringQuestions }, idx) => (
        <StyledList key={`${message}-${idx}`} data-testid={`alert-item-${idx}`}>
          <AlertAccordionDetailsAlertHeader>
            {message}
          </AlertAccordionDetailsAlertHeader>
          <AlertAccordionDetailsAlertSubheader>
            {t(
              'Procedure.Alerts.The following question(s) resulted in this alert',
            )}
          </AlertAccordionDetailsAlertSubheader>
          <AlertAccordionDetailsQuestionsList>
            {triggeringQuestions.map((varName) => (
              <AlertAccordionDetailsQuestionsListItem key={varName}>
                {questionTextMap[varName]}
              </AlertAccordionDetailsQuestionsListItem>
            ))}
          </AlertAccordionDetailsQuestionsList>
        </StyledList>
      ))}
    </AlertAccordionDetailsList>
  );
};
